module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-600.c7b0ad5d.woff2";